import styled from 'styled-components';
import PaginationControls from 'library/components/search-table/pagination-controls';

const Layout = styled.div`
  height: 100%;
  min-height: min-content;
  background: #fff;
  @media(min-width: 768px) {
    display: flex;
  }
`;

const LeftSidebar = styled.div`
  padding: 0.5em 1.375em;
  box-shadow: 1px 3px 6px 0 rgba(0,0,0,0.11);
  background: #fff;
  flex: 0 0 300px;
`;

const FilterArea = styled.div`
  grid-area: FilterArea;
`;

const FilterPanel = styled.div`
  min-height: 300px;
  border-bottom: 1px solid #DFE3E4;
`;

const SearchHeader = styled.h1`
  font-size: 1.375em;
  color: #595959;
  display: flex;
  justify-content: left;
  align-items: center;
`;

const UserTableBody = styled.div`
  padding: 1.8125em;
  min-height: calc(100vh - 64px);
  flex: 1;
  overflow-x: auto;
`;

const TableAndSearch = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-x: auto;
`;

const Header = styled.h1`
  font-size: 1.75em;
  color: #a9a9a9;
  padding: 0;
  margin: 0;
`;

const Pagination = styled(PaginationControls)`
  margin: 1em;
`;

export {
  Layout,
  LeftSidebar,
  FilterArea,
  FilterPanel,
  SearchHeader,
  UserTableBody,
  TableAndSearch,
  Header,
  Pagination
};
